import React from "react";
import CurrencyFormat from "react-currency-format";

type Props = {
  value: number;
};

const Index: React.FC<Props> = ({ value }) => {
  return (
    <CurrencyFormat
      value={value}
      displayType="text"
      thousandSeparator={true}
      // suffix=" 円 "
      prefix="¥ "
    
    />
  );
};

export default Index;
